// extracted by mini-css-extract-plugin
export default {"divider":"js-z"};